import React from 'react';
import './Footer.css'; // Make sure to import or include your CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">

          <div className="footer-col address">
            <h4>PatangBazaar</h4>
            <ul>
            <li style={{marginBottom: "15px"}}><a href="#">Buy as soon as possible with good offers</a></li>
              <li><a href="#"><i class="fa-solid fa-house"></i> Jaipur, Rajasthan, India</a></li>
              <li><a href="#"><i class="fa-solid fa-phone"></i>    +91 999999999</a></li>
              <li><a className='addresss' href="#"><i class="fa-solid fa-envelope-open"></i>    mittalnaman08@gmail.com</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>company</h4>
            <ul>
              <li><a href="#">about us</a></li>
              <li><a href="#">our services</a></li>
              <li><a href="#">Shipping & Delivery</a></li>
              <li><a href="#">privacy policy</a></li>
              {/* <li><a href="#">affiliate program</a></li> */}
            </ul>
          </div>
          <div className="footer-col">
            <h4>online shop</h4>
            <ul>
              <li><a href="#">Patang</a></li>
              <li><a href="#">Manja</a></li>
              <li><a href="#">Lantern</a></li>
              <li><a href="#">Kids Section</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>follow us</h4>
            <div className="social-links">
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
